import { Fragment, FunctionComponent, memo, useMemo } from "react";

import AnomalyTags from "components-for/anomalies/anomaly-tags";
import { groupTags } from "utilities/group-tags";

import { IProps } from "./anomaly-tag-groups.types";
import "./anomaly-tag-groups.scss";

/**
 * Display an anomaly's tags, split into tag group.
 * @param props.tags All tags belong to an anomaly's model.
 * @returns          Tags in groups.
 */
const AnomalyTagGroups: FunctionComponent<IProps> = ({ tags, ...anomalyDetailProps }) => {
    const groupedTags = useMemo(() => groupTags(tags), [tags]);
    return (
        <Fragment>
            {groupedTags.map(([tagGroup, tags]) => (
                <AnomalyTags {...anomalyDetailProps} key={tagGroup} label={tagGroup} tags={tags} />
            ))}
        </Fragment>
    );
};

export default memo(AnomalyTagGroups);
